import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';
import Dispatch from '@vaersaagod/tools/Dispatch';
import request from '@vaersaagod/tools/request';
import * as Events from '../lib/events';

export default (el, props) => {
    const dom = $(el);
    const bar = dom.find('[data-header-bar]');
    const colorLinks = dom.find('[data-color]');
    const menu = dom.find('[data-menu]');
    const imageContainer = dom.find('[data-menu-image]');
    const imageContainerInner = dom.find('[data-menu-image-inner]');
    const creativesContainer = dom.find('[data-creatives]');
    const creativesContainerInner = dom.find('[data-creatives-inner]');
    const trigger = dom.find('[data-menu-trigger]');
    const defaultImage = dom.find('[data-image="0"]');
    
    let images = null;
    let currentBreakpoint;
    let imagesLoaded = false;
    let menuOpen = false;
    let textColor = dom.data('text-color');

    const onHover = e => {
        const node = e.triggerTarget;
        creativesContainer.css('background', $(node).data('color'));

        if (images && imagesLoaded) {
            images.filter(i => $(i).hasClass('js-show')).removeClass('js-show');
            const image = images.filter(i => $(i).data('image') === $(node).data('person'));

            if (image.length) {
                image.addClass('js-show');
            } else if (defaultImage.length) {
                defaultImage.addClass('js-show');
            }
        }
    };

    const shouldLoadImages = () => !imagesLoaded && currentBreakpoint >= 1200;

    const loadImages = () => {
        imagesLoaded = true;

        request.get('/menu-images').then(res => {
            const { text } = res || {};
            imageContainerInner.append($(text).html());
            images = imageContainerInner.find('[data-image]');
            imageContainerInner.find('.lazyload').addClass('lazypreload');
        }, error => {
            console.error(error);
            imagesLoaded = false;
        });
    };

    const openMenu = () => {
        if (!menuOpen) {
            document.addEventListener('keyup', keyup);
            
            if (shouldLoadImages()) {
                loadImages();
            }
            
            menuOpen = true;
            dom.addClass('has-open-menu');
            
            imageContainer.css('height', 0);
            creativesContainer.css('height', 0);
            creativesContainerInner.css('opacity', 1);
            
            let innerElements = creativesContainerInner.find('h3, li');
            TweenMax.set(innerElements.nodes, { opacity: 0, y: 100 });
            
            /*
            creativesContainer.css('height', 0);
            */
            
            TweenMax.to(imageContainer.get(0), 0.8, { height: '100%', ease: Quint.easeIn});
            TweenMax.to(creativesContainer.get(0), 0.6, { height: '100%', ease: Quint.easeIn, onComplete: () => {
                creativesContainerInner.addClass('is-open');
                // creativesContainerInner.css('overflow-y', 'scroll');
                // creativesContainerInner.css('-webkit-overflow-scroll', 'touch');
                TweenMax.staggerTo(innerElements.nodes, 0.5, { opacity: 1, ease: Sine.easeOut }, 0.008);
                TweenMax.staggerTo(innerElements.nodes, 0.8, { y: 0, ease: Quint.easeOut }, 0.008);
            } });
        }
    };

    const closeMenu = () => {
        if (menuOpen) {
            document.removeEventListener('keyup', keyup);
            
            menuOpen = false;
            
            TweenMax.to(creativesContainerInner.get(0), 0.25, { opacity: 0, ease: Sine.easeIn, onComplete: () => {
                TweenMax.to(creativesContainer.get(0), 0.7, { height: '0%', ease: Quint.easeInOut });
                TweenMax.to(imageContainer.get(0), 1.1, { height: '0%', ease: Quint.easeInOut, onComplete: () => {
                    creativesContainerInner.removeClass('is-open');
                    // creativesContainerInner.css('overflow-y', '');
                    // creativesContainerInner.css('-webkit-overflow-scroll', '');
                    dom.removeClass('has-open-menu');
                } });
            } });
        }
    };

    const toggleMenu = e => {
        e.preventDefault();

        if (menuOpen) {
            closeMenu();
            return;
        }

        openMenu();
    };

    const keyup = e => {
        const key = e.keyCode || e.which;
        if (menuOpen && key === 27) {
            closeMenu();
        }
    };
    

    const updateTextColor = color => {
        if (textColor !== color) {
            dom.removeClass(`js-text-${textColor}`).addClass(`js-text-${color}`);
            textColor = color;
        }
    };

    const onHeroSlide = (key, data) => {
        updateTextColor(data.textColor);
    };

    const onBreakpoint = data => {
        currentBreakpoint = Viewport.breakpoint.size;

        if (currentBreakpoint >= 1200 && data.detail.old.size < 1200) {
            colorLinks.on('mouseenter', onHover);
        } else if (currentBreakpoint < 1200 && data.detail.old.size >= 1200) {
            colorLinks.off('mouseenter', onHover);
        }
    };

    const init = () => {
        currentBreakpoint = Viewport.breakpoint.size;
        Viewport.on('breakpoint', onBreakpoint);

        if (defaultImage.length) {
            defaultImage.addClass('js-show');
        }

        if (currentBreakpoint >= 1200) {
            colorLinks.on('mouseenter', onHover);
        }
        
        if (bar.hasClass('is-hidden')) {
            setTimeout(() => {
                bar.removeClass('is-hidden');
            }, 500);
            
            window.vrsg.setCookie('pudderHeaderWasAnimated', '1');
        }

        trigger.on('click', toggleMenu);
        Dispatch.on(Events.HERO_SLIDE, onHeroSlide);
    };

    const destroy = () => {
        Dispatch.off(Events.HERO_SLIDE, onHeroSlide);
        colorLinks.off('mouseenter', onHover);
        trigger.off('click', toggleMenu);
        Viewport.off('breakpoint', onBreakpoint);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Header.js